import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import { ConfirmCodeFormProps } from "./types";
import Input from "shared/ui/Input";
import { useNavigate } from "react-router-dom";
import Button from "shared/ui/Button";
import { handleLogin } from "../lib/handleLogin";
import { useAppDispatch } from "shared/redux/hooks";
import { useCookies } from "react-cookie";
import { RegistrationApi } from "../api";
import { formatPhone } from "shared/lib/formatPhone";
import { showError } from "shared/lib/showError";
import Checkbox from "shared/ui/Checkbox";
import { GetServiceDataApi, IServiceData } from "shared/api/serviceData";

const ConfirmCodeForm: React.FC<ConfirmCodeFormProps> = ({ phone }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [, setCookie] = useCookies(["auth_key", "user_id"]);

  const [rulesChecked, setRulesChecked] = useState(false);
  const [personalDataChecked, setPersonalDataChecked] = useState(false);
  const [personalDataPolicyChecked, setPersonalDataPolicyChecked] =
    useState(false);
  const [serviceData, setServiceData] = useState<IServiceData | null>(null);
  const [code, setCode] = useState("");
  const [promocode, setPromocode] = useState("");
  const [dataSending, setDataSending] = useState(false);

  const buttonDisabled =
    dataSending ||
    !rulesChecked ||
    !personalDataChecked ||
    !personalDataPolicyChecked ||
    code.trim() === "";

  useEffect(() => {
    GetServiceDataApi({ id: 1 })
      .then((res) => {
        setServiceData(res);
      })
      .catch((e) => {
        showError(e, dispatch);
      });
  }, [dispatch]);

  const handleResend = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setDataSending(true);

    RegistrationApi({ confirm: 1, msisdn: formatPhone(phone) })
      .catch((e) => {
        showError(e, dispatch);
      })
      .finally(() => setDataSending(false));
  };

  return (
    <form className={s.form}>
      <p>На номер телефона {phone} был отправлен код</p>

      <Input className={s.code} mask={String} setValue={setCode} value={code} />

      <div className={s.rules}>
        <Checkbox
          checked={rulesChecked}
          setChecked={setRulesChecked}
          id="rules"
          label={
            <span>
              Принимаю условия{" "}
              <a
                href={serviceData?.rules_link}
                target="_blank"
                rel="noreferrer"
              >
                Пользовательского соглашения и правил
              </a>
            </span>
          }
        />

        <Checkbox
          checked={personalDataChecked}
          setChecked={setPersonalDataChecked}
          id="personal-data"
          label={
            <span>
              Согласен на обработку моих{" "}
              <a
                href={serviceData?.link_rules}
                target="_blank"
                rel="noreferrer"
              >
                персональных данных
              </a>
            </span>
          }
        />

        <Checkbox
          checked={personalDataPolicyChecked}
          setChecked={setPersonalDataPolicyChecked}
          id="personal-data-policy"
          label={
            <span>
              С{" "}
              <a href={serviceData?.pd_link} target="_blank" rel="noreferrer">
                Политикой обработки персональных данных
              </a>
              {" "}ознакомлен
            </span>
          }
        />
      </div>

      <Input
        mask={String}
        value={promocode}
        setValue={setPromocode}
        placeholder="Промокод"
        className={s.promocode}
      />

      <Button
        disabled={buttonDisabled}
        className={s.button}
        onClick={() =>
          handleLogin({
            code,
            dispatch,
            navigate,
            phone,
            setCookie,
            setDataSending,
          })
        }
      >
        Отправить
      </Button>

      <button
        className={s.resend}
        onClick={handleResend}
        disabled={dataSending}
      >
        Код не получен, отправить повторно
      </button>
    </form>
  );
};

export default ConfirmCodeForm;
